// extracted by mini-css-extract-plugin
export default {"zoomModal":"G3-z"};